import { FC } from 'react';
import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
  ToggleButtonProps,
} from '@mui/material';

type BooleanFieldOption = ToggleButtonProps & { label: string; value: boolean | string };

export type BooleanFieldProps = Omit<ToggleButtonGroupProps, 'onChange'> & {
  'aria-label': string;
  onChange: (value?: boolean) => void;
  options: BooleanFieldOption[];
  value?: boolean;
};

const BooleanField: FC<BooleanFieldProps> = ({
  'aria-label': ariaLabel,
  options,
  exclusive = true,
  onChange,
  size = 'small',
  ...rest
}) => (
  <ToggleButtonGroup
    aria-label={ariaLabel}
    exclusive={exclusive}
    onChange={(_, newValue) => onChange(newValue)}
    size={size}
    {...rest}
  >
    {options.map(({ label, size = 'small', value, ...rest }) => (
      <ToggleButton key={value.toString()} size={size} value={value} {...rest}>
        {label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);

export default BooleanField;
